/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ discount_yearly_price: NonNullable<unknown> }} Allowlist_Paywall_Subscription_BtnInputs */

const en_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const ar_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const de_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const es_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const fr_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const it_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const ja_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const ko_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const pt_br_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const ru_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const th_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const tr_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get 1 Year Plus Membership ${i?.discount_yearly_price}`)
};

const zh_cn_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开通会员 1 年 ${i?.discount_yearly_price}`)
};

const zh_tw_allowlist_paywall_subscription_btn = /** @type {(inputs: Allowlist_Paywall_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开通会员 1 年 ${i?.discount_yearly_price}`)
};

/**
* | output |
* | --- |
* | "Get 1 Year Plus Membership {discount_yearly_price}" |
*
* @param {Allowlist_Paywall_Subscription_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const allowlist_paywall_subscription_btn = /** @type {((inputs: Allowlist_Paywall_Subscription_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allowlist_Paywall_Subscription_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_allowlist_paywall_subscription_btn(inputs)
	if (locale === "ar") return ar_allowlist_paywall_subscription_btn(inputs)
	if (locale === "de") return de_allowlist_paywall_subscription_btn(inputs)
	if (locale === "es") return es_allowlist_paywall_subscription_btn(inputs)
	if (locale === "fr") return fr_allowlist_paywall_subscription_btn(inputs)
	if (locale === "it") return it_allowlist_paywall_subscription_btn(inputs)
	if (locale === "ja") return ja_allowlist_paywall_subscription_btn(inputs)
	if (locale === "ko") return ko_allowlist_paywall_subscription_btn(inputs)
	if (locale === "pt_br") return pt_br_allowlist_paywall_subscription_btn(inputs)
	if (locale === "ru") return ru_allowlist_paywall_subscription_btn(inputs)
	if (locale === "th") return th_allowlist_paywall_subscription_btn(inputs)
	if (locale === "tr") return tr_allowlist_paywall_subscription_btn(inputs)
	if (locale === "zh_cn") return zh_cn_allowlist_paywall_subscription_btn(inputs)
	return zh_tw_allowlist_paywall_subscription_btn(inputs)
});